import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addCommentSuccess,
  addCommentFailure,
  //
  deleteCommentSuccess,
  deleteCommentFailure,
  //
  editCommentSuccess,
  editCommentFailure,
  //
  fetchComments as fetchCommentAction,
  fetchCommentsSuccess,
  fetchCommentsFailure,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_COMMENT,
  DELETE_COMMENT,
  EDIT_COMMENT,
  FETCH_COMMENTS,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchCommentsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const comments = yield select((state) => state?.CommentReducer.comments);

  let query = payload ? QueryString.stringify(payload) : "";
  let updatesResponse = { ...comments };
  try {
    const { data } = yield call(api(token).get, `/api/feed-comment?${query}`);
    if (payload?.page <= 1) {
      updatesResponse = data;
    } else {
      updatesResponse = {
        ...data,
        data: updatesResponse.data.concat(data?.data),
      };
    }
    yield put(fetchCommentsSuccess(updatesResponse));
  } catch (e) {
    yield put(fetchCommentsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching comment list!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/feed-comment/${payload}`);
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching terminal data!"));
  }
}

export function* addCommentSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/feed-comment/add`,
      payload
    );
    if (data) {
      yield put(addCommentSuccess());
      typeof onAdd === "function" && onAdd(data);
    }
  } catch (e) {
    yield put(addCommentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editCommentSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/feed-comment/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Comment updated successfully!"));
      yield put(editCommentSuccess());
      typeof onEdit === "function" && onEdit(data);
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editCommentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteCommentSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/feed-comment/${payload}`);
    if (data) {
      yield put(successAlert("Comment deleted successfully!"));
      yield put(deleteCommentSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteCommentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchCommentsFlow() {
  yield takeEvery(FETCH_COMMENTS, fetchCommentsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addCommentFlow() {
  yield takeEvery(ADD_COMMENT, addCommentSaga);
}
export function* editCommentFlow() {
  yield takeEvery(EDIT_COMMENT, editCommentSaga);
}
export function* deleteCommentFlow() {
  yield takeEvery(DELETE_COMMENT, deleteCommentSaga);
}

export default function* CommentSaga() {
  yield all([
    fetchCommentsFlow(),
    addCommentFlow(),
    editCommentFlow(),
    deleteCommentFlow(),
    getViewDataFlow(),
  ]);
}
